import Ripple from './ripple';
import Touch from './touch';
import ClickOutside from './click-outside';
import TransferDom from './transfer-dom';
import Mousewheel from './mousewheel';
import Outside from './outside';
import LineClamp from './line-clamp';

export default {
  Ripple,
  Touch,
  ClickOutside,
  TransferDom,
  Mousewheel,
  LineClamp,
};

export { Mousewheel, ClickOutside, Outside, TransferDom };
